import PropTypes from 'prop-types';
import React from 'react';
import SearchBarTerm from './SearchBarTerm';
import styles from './SearchBar-style.scss';
import { createSearchLink } from '../../utils/sharedSearchBarHelpers';

const SearchBarSection = ({
    urlSection,
    title,
    terms,
    handleRowClick,
    cursorHighlightId,
    type,
}) => (
    <div className={styles.section}>
        <div className={styles.header}>{title}</div>
        {terms.map(({ term, urlLabel }, index) => {
            const href = createSearchLink({ term, urlSection, urlLabel, type });
            return (
                <SearchBarTerm
                    key={term}
                    id={`${term}-${type}-${index}`}
                    term={term}
                    type={type}
                    href={href}
                    handleRowClick={handleRowClick}
                    cursorHighlightId={cursorHighlightId}
                />
            );
        })}
    </div>
);

SearchBarSection.propTypes = {
    title: PropTypes.string,
    terms: PropTypes.array,
    urlSection: PropTypes.string,
    handleRowClick: PropTypes.func,
    cursorHighlightId: PropTypes.string,
    type: PropTypes.string,
};

export default SearchBarSection;
